import script from "./WorkspaceIntervals.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceIntervals.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceIntervals.vue?vue&type=style&index=0&id=574b2858&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574b2858"]])

export default __exports__